import { CORNER_LOGO_PATH, CORNER_LOGO_VIEWBOX_H, CORNER_LOGO_VIEWBOX_W } from "./cornerLogoPath";

type Props = {
    color?: string;
    width?: string | number;
    height?: string | number;
    viewBox?: string;
};

export default function DLogo({
    color = "#3D9CF5",
    width = 200,
    height = 187,
    viewBox = `0 0 ${CORNER_LOGO_VIEWBOX_W} ${CORNER_LOGO_VIEWBOX_H}`,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform={`rotate(90, ${CORNER_LOGO_VIEWBOX_W / 2}, ${CORNER_LOGO_VIEWBOX_H / 2}) scale(-1,1) translate(-${CORNER_LOGO_VIEWBOX_W},0)`}>
                <path fill={color} d={CORNER_LOGO_PATH} />
            </g>
        </svg>
    );
}
